module.exports = __webpack_public_path__ + "img/Group 1000002996.46805b46.svg";